import {
    INTAKE_FORM_ADD_PET,
    INTAKE_FORM_RESET,
    INTAKE_FORM_SET_CUSTOMER,
    INTAKE_FORM_SET_LOADING,
    INTAKE_FORM_SET_PETS,
    INTAKE_FORM_SET_STEP,
    INTAKE_FORM_UPDATE_PET,
    IntakeFormAction
} from 'actions/intakeForm/IntakeFormActionsTypes';
import { Reducer } from 'react';
import { IntakeFormState, IntakeFormStep } from 'reducers/intakeForm/IntakeFormState';
import { CustomerChannel, emptyCustomer } from 'types/Customer';

const initialState: IntakeFormState = {
    loading: false,
    step: IntakeFormStep.Initial,
    customer: emptyCustomer(CustomerChannel.INTAKE_FORM),
    pets: []
};

export const intakeFormReducer: Reducer<IntakeFormState, IntakeFormAction> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case INTAKE_FORM_RESET:
            return initialState;
        case INTAKE_FORM_SET_STEP:
            return {
                ...state,
                step: action.payload.step
            };
        case INTAKE_FORM_SET_LOADING:
            return {
                ...state,
                loading: action.payload.loading
            };
        case INTAKE_FORM_SET_CUSTOMER:
            return {
                ...state,
                customer: action.payload.customer
            };
        case INTAKE_FORM_ADD_PET:
            return {
                ...state,
                pets: [...state.pets, action.payload.pet]
            };
        case INTAKE_FORM_UPDATE_PET:
            return {
                ...state,
                pets: state.pets.map(pet =>
                    pet.uuid === action.payload.pet.uuid ? action.payload.pet : pet
                )
            };
        case INTAKE_FORM_SET_PETS:
            return {
                ...state,
                pets: action.payload.pets
            };
        default:
            return state;
    }
};
